import {
  getImageBase64,
  getBackground
  , getThemePic
} from "@/views/home/slidePPT/use/methods"
const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme)

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "ez4QTlULh9",
        width: 420.5395341207349,
        height: 385.8695866141732,
        left: 514.2880577427821,
        top: 109.71456692913385,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}C7`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.9,
      },
      {
        type: "shape",
        id: "37To3b2BJx",
        width: 420.5395341207349,
        height: 385.8695866141732,
        left: 62.65001640419948,
        top: 109.71456692913385,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}C7`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.9,
      },
      {
        type: "shape",
        id: "WogGdoLhht",
        width: 167.12819881889763,
        height: 41.49794947506562,
        left: 62.01837270341207,
        top: 109.71456692913385,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "jb_wTJgSEt",
        width: 54.39247047244094,
        height: 41.49794947506562,
        left: 195.69873687664042,
        top: 109.71456692913385,
        viewBox: [54.39247047244094, 41.49794947506562],
        path: "M 13.598117618110235 0 L 54.39247047244094 0 L 40.794352854330704 41.49794947506562 L 0 41.49794947506562 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        pathFormula: "parallelogramLeft",
        keypoint: 0.25,
      },
      {
        type: "shape",
        id: "1rBQA_Wjq-",
        width: 167.12819881889763,
        height: 41.49794947506562,
        left: 514.2880577427821,
        top: 109.71456692913385,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7TujojaYHT",
        width: 54.39247047244094,
        height: 41.49794947506562,
        left: 647.9684219160105,
        top: 109.71456692913385,
        viewBox: [54.39247047244094, 41.49794947506562],
        path: "M 13.598117618110235 0 L 54.39247047244094 0 L 40.794352854330704 41.49794947506562 L 0 41.49794947506562 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        pathFormula: "parallelogramLeft",
        keypoint: 0.25,
      },
      {
        type: "text",
        id: "zRyLiKVhRb",
        width: 352.0733267716535,
        height: 104,
        left: 96.19151902887138,
        top: 163.35096784776903,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;"><span style="color: ${color};">${node.children[0].title || ""
          }</span></span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "zOF5l54zRI",
        width: 352.0733267716535,
        height: 203.75,
        left: 96.19151902887138,
        top: 248.3434219160105,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><span style="font-size: 14.0625px;"><span style="font-family: Microsoft Yahei;"><span style="color: #ffffff;">${node.children[0].text}</span></span></span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "CcpOxcg71i",
        width: 95.78239829396325,
        height: 55,
        left: 99.91633858267717,
        top: 102.30626640419948,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content:
          '<p style=""><strong><span style="font-size: 20.3125px;"><span style="font-family: Microsoft Yahei;"><span style="color: #FFFFFF;">要点一</span></span></span></strong></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "ol01EKb8Mw",
        width: 95.78239829396325,
        height: 55,
        left: 555.7099737532808,
        top: 103.51041666666667,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content:
          '<p style=""><strong><span style="font-size: 20.3125px;"><span style="font-family: Microsoft Yahei;"><span style="color: #FFFFFF;">要点二</span></span></span></strong></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "HUHyfMAkYq",
        width: 352.0733267716535,
        height: 104,
        left: 552.5211614173228,
        top: 163.35096784776903,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;"><span style="color: ${color};">${node.children[1].title || ""
          }</span></span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "dhs_8dPjgE",
        width: 352.0733267716535,
        height: 203.75,
        left: 552.5211614173228,
        top: 248.3434219160105,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><span style="font-size: 14.0625px;"><span style="font-family: Microsoft Yahei;"><span style="color: #ffffff;">${node.children[1].text}</span></span></span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "WfK8AniL4o",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "k5YFnkipCH",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hu1S8SQKgy",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "gbN8jFf7hQ",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "O7zbpL48la",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "1O4svW0EEu",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "4Yjy6cNdgp",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "WoHOor9Jpk",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_dHa17UPyS",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "n9OUqCio2u",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "MUMMMnemfZ",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "dQhiUBufOH",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "h17HKIdxye",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "l-FwTGYLmT",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "kwIGQlQISc",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "MN7kbJihLX",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "qMoK5sCgzR",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "N7EIxc90Yo",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "UnIS7MP3-V",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "p9pVWRqp3f",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "Bx42mZbhBs",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: Microsoft Yahei;">${node.title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "GOXVGxp5VU",
        width: 57.53510498687664,
        height: 10.088418635170603,
        left: 41.656332020997375,
        top: 513.2853510498687,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "wZxJTLtLkm",
        width: 10.088418635170603,
        height: 10.088418635170603,
        left: 37.31651902887139,
        top: 513.2853510498687,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_qT4E7VRhi",
        width: 10.088418635170603,
        height: 10.088418635170603,
        left: 93.31651902887138,
        top: 513.2853510498687,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "line",
        id: "tx09YRwA7Z",
        width: 1.1250393700787402,
        left: 99.19151902887138,
        top: 524.3737696850394,
        start: [0, 0],
        end: [901.5626640419947, 0],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
    ],
    background
  };
};

export default nodule;
